<div class="container" [style.width.px]="width">
  <ng-container *ngFor="let items of [leftItems, rightItems]">
    <div>
      <a class="item hover-underline" *ngFor="let item of items"
         [routerLink]="item.link"
         [matTooltip]="item.tooltip">
        {{item.name}}
      </a>
    </div>
  </ng-container>
</div>
